import React, { useRef, useState, useEffect, useContext } from "react";
import PageNav from "../components/PageNav";
import classNames from "classnames";
import NewNotes from "./NewNotes";
import { Notesvg } from "../svg/Notesvg";
import Featured from '../components/Featured';
// import useOnClick from '../components/common/ClosePopUp';
import { AuthContext } from "../context/AuthContext";
import axios from 'axios';
import Button from '../components/common/Button';
import { animated, useSpring } from "react-spring";
import loadingSpin from '../images/loadingSpin.gif';
import NtwrkErrMsg from "../components/common/NtwrkErrMsg";
import EmptyContent from "../components/common/EmptyContent";

const Notes = () => {
    const authContext = useContext(AuthContext);
    // const studentId = authContext.studentInfo[0].studentId;
    const studentInfo = JSON.parse(localStorage.getItem('studentInfo'))?.[0] || {};
    const id = JSON.parse(localStorage.getItem('studentInfo'));
    const studentId = id[0].studentId;
    const schoolDomain = localStorage.getItem('schoolDomain');
    const deploymentIdx = JSON.parse(localStorage.getItem('subSchoolData')).idx;

    const [fetchedNotes, setFetchedNotes] = useState([]);
    // const [noNotes, setNoNotes] = useState(false);
    const [newNote, setNewNote] = useState(true);
    const [searchedNote, setSearchedNote] = useState(false);
    const [fetchedSearchedNotes, setFetchedSearchedNotes] = useState([]);
    const [date, setDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [ fetchError, setFetchError ] = useState(false);
    const [ loadingAll, setLoadingAll ] = useState(false);

    useEffect(() => {
        const getNotes = async () => {
            try {
                setLoadingAll(true)
                
                const { data } = await axios.get(
                    `${authContext.baseUrl}/student/lessonNotes/${schoolDomain}/${studentId}/${deploymentIdx}?session=${studentInfo?.current_session}&term=${studentInfo?.current_term}&class=${studentInfo.current_class}`
                );

                // console.log(data)
                if(data.status) {
                    setSearchedNote(true);
                    setNewNote(true);
                    data.data.length > 0 && setFetchedNotes(data.data[0].Available_Notes);
                    setLoadingAll(false)
                } else {
                    setLoadingAll(false)
                }
                // console.log(data.data[0].Available_Notes);
            } catch (error) {
                // console.log(error, 'fetchError');
                setLoadingAll(false)
                setFetchError(true);
            }
        };
        getNotes();
        return () => {}
    }, [])

    const showNoNotes = classNames({
        "flex justify-center w-full mt-16": true,
    });

    const Heading = () => (
        <>
            <span className="text-2xl leading-7 text-white mt-1"> Notes </span>
        </>
    );
    const pageSvg = () => (
        <>
            <Notesvg />
        </>
    );

    const ref = useRef()

    // useOnClick(ref, ()=> setDisplayDropdown(false))

    const handleChange = (e) => {
        setDate(e.target.value)
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            setLoading(true);
            setNewNote(false);
            const { data } = await axios.get(`${authContext.baseUrl}/student/lessonNotes/${schoolDomain}/${studentId}/${deploymentIdx}?datefilter=${date}`);
            // console.log(data.data)
            // console.log(date);
            data.status && setSearchedNote(true);
            setLoading(false);
            if (data.data.length === 0) {
                setSearchedNote(false);
            };
            data.data.length && setFetchedSearchedNotes(data.data[0].Available_Notes);
        } catch (error) {
            setFetchError(true)
            // console.log(error)
        }
    };

    const transitionStyles = useSpring({
        to: [
        { opacity: 1, transform: 'translateX(0)' },
        ],
        from: { opacity: 0, transform: 'translateX(80px)' },
        config: { duration: 1000 }
    });

    return (
        <>
            <div className="px-4 sm:flex sm:px-0">
                <animated.div style={transitionStyles} className="w-full sm:w-2/3">
                    <PageNav Heading={Heading} PageSvg={pageSvg} />
                    <div className="pt-6 w-full">
                        <div className="flex items-center">
                            <span className="font-bold mr-1 sm:mr-4 text-sm sm:text-base"> Filter: </span>
                            <form onSubmit={handleSubmit} className='flex flex-row sm:flex-row'>
                                <input
                                    className='mt-2 sm:mt-0'
                                    type='date'
                                    value={date}
                                    onChange={handleChange}
                                />

                                <div className='ml-2 sm:ml-4 my-2 mt-4 sm:mt-2'>
                                    <Button
                                        type='submit'
                                        text='Search'
                                        loading={loading}
                                    />
                                </div>
                            </form>
                        </div>

                        {
                            loadingAll &&
                            <div className='flex justify-center w-full h-full my-24'>
                                <img src={loadingSpin} alt='loading...' />
                            </div>
                        }

                        {
                            fetchedNotes && fetchedNotes.length === 0 && !loadingAll && !fetchError &&
                            <div className='flex justify-center w-full sm:mt-16'>
                                <EmptyContent message='No notes' moreMessage='Notes uploaded by teachers would be displayed here' />
                            </div>
                        }

                        {
                            searchedNote === false && !fetchError && !loadingAll && 
                            <div className={showNoNotes}>
                                <EmptyContent message='No notes for this date' moreMessage='Notes uploaded by teachers would be displayed here' />
                            </div>
                        }

                        {
                            newNote &&
                            <div className="mt-4 w-full">
                                <NewNotes fetchedNotes={fetchedNotes} />
                            </div>
                        }

                        {
                            searchedNote &&
                            <div className="mt-4 w-full">
                                <NewNotes fetchedNotes={fetchedSearchedNotes} />
                            </div>
                        }

                        {
                            fetchError &&
                            <NtwrkErrMsg errMsg = 'Oops! Something Went Wrong' showReload = { true } />
                        }
                    </div>
                </animated.div>
                <div className="w-full sm:w-1/3 sm:mx-4 mt-6">
                    <Featured />
                </div>
            </div>
        </>
    )
}

export default Notes;